import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  DISABLE_ERROR_ALERT_HEADER,
  TAnalyticsSearchRequestBase,
  TAnalyticsSearchResponseBase,
  TRESPONSE_GET_ANALYTICS_CONFIG,
} from '@monorepo/types';
import { AnalyticsEnvironmentService } from './analytics-environment.service';
// import { getMockAnalyticsConfig, getMockAnalyticsSearchResponse, USE_ANALYTICS_MOCK } from './analytics.mock';

@Injectable()
export class AnalyticsDataService {
  constructor(private http: HttpClient, private analyticsEnvironmentService: AnalyticsEnvironmentService) {}

  fetchPlani8InHouseConfig() {
    // if (USE_ANALYTICS_MOCK) return getMockAnalyticsConfig();
    const url = this.analyticsEnvironmentService.getUrlFromEnv('GET_PLANI8_IN_HOUSE_CONFIG');
    return this.http.get<TRESPONSE_GET_ANALYTICS_CONFIG>(url);
  }

  analyticsSearch<TRequest extends TAnalyticsSearchRequestBase, TResponse extends TAnalyticsSearchResponseBase>(
    payload: TRequest,
  ) {
    // if (USE_ANALYTICS_MOCK) return getMockAnalyticsSearchResponse<TResponse>(payload);
    const url = this.analyticsEnvironmentService.getUrlFromEnv('SEARCH_ANALYTICS');
    return this.http.post<TResponse>(url, payload, {
      headers: new HttpHeaders({ [DISABLE_ERROR_ALERT_HEADER]: 'true' }),
    });
  }
}
